// Module
var code = `<div class="modal-dialog" role="document" data-bind="css: { 'modal-lg': wideDialog }">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" data-bind="text: title"></h5>
            <button type="button" class="close" data-bind="click: close, clickBubble: false" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
        </div>
        <div class="modal-body">
            <p class="confirmationMessage" data-bind="html: confirmationMessageAsHtml"></p>
        </div>
        <div class="modal-footer" data-bind="foreach: buttonOptions">
            <button type="button" class="btn" data-bind="text: \$data, click: \$root.onOptionClicked.bind(\$root), clickBubble: false, 
                    css: { 'btn-default': \$index() !== \$root.buttonOptions.length - 1, 'btn-primary': \$index() === \$root.buttonOptions.length - 1 }">
            </button>
        </div>
    </div>
</div>
`;
// Exports
export default code;